const ignorePrepositionalWord: Array<String> = ["de", "del"]

const formatCodes: Array<String> = [
	"bod",
	"hi",
	"ex",
	"sba",
	"ba",
	"ek",
	"cm",
	"lider",
]

export const capitalize = (word: string | undefined): string | undefined => {
	return capitalizeFirst(word)
		.split(" ")
		.reduce(
			(acc, curr) => `${acc} ${curr.charAt(0).toUpperCase()}${curr.slice(1)}`
		)
}

export const capitalizeFirst = (word: string | undefined): string => {
	return `${word?.charAt(0).toUpperCase()}${word?.slice(1).toLowerCase()}`
}

export const titleCapitalize = (value: string): string =>
	value
		.toLowerCase()
		.split(" ")
		.map((word) => {
			if (ignorePrepositionalWord.find((preps) => preps === word)) {
				return word
			}
			if (formatCodes.find((format) => format === word)) {
				return word.toUpperCase()
			}
			return `${word.substring(0, 1).toUpperCase()}${word.substring(1)}`
		})
		.join(" ")

export const formatItemName = (name: string): string => {
	const maxLength = 30
	if (name?.length > maxLength) {
		return `${name.slice(0, maxLength)}...`
	}
	return name
}
export const isEmptyString = (str: string) => str.length === 0

export const dashesToUnderscore = (str?: string) =>
	typeof str === "string" ? str?.replace(new RegExp("-", "g"), "_") : str
